import { render, staticRenderFns } from "./ScopeShow.vue?vue&type=template&id=3063c127&"
import script from "./ScopeShow.vue?vue&type=script&lang=js&"
export * from "./ScopeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports